import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductsService } from '../../../services/products.service';
import { Product } from '../../../interfaces/product';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ToastsManager } from 'ng2-toastr';
import { LoggerService } from '../../../services/logger.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ProductSyncStatusInterface } from '../../../interfaces/product-sync-status.interface';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  public products: Product[];
  public dataSource: MatTableDataSource<Product>;
  public displayedColumns = ['name', 'type', 'price', 'aliases', 'externalProductCodes', 'delete'];
  public isLoadingResults = false;
  public syncStatuses$: Observable<ProductSyncStatusInterface[]>;

  constructor(
    private productsService: ProductsService,
    private toastr: ToastsManager,
    public translate: TranslateService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.isLoadingResults = true;
    this.syncStatuses$ = this.productsService.getSyncStatuses();
    this.productsService.getProducts({}).subscribe(
      products => {
        this.products = products;
        this.dataSource = new MatTableDataSource(this.products);
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      },
      error => {
        LoggerService.log('ProductListComponent::ngOnInit', error);
        this.toastr.error(this.translate.instant('PRODUCT_LIST.COMPONENT.DATA_ERROR'));
      }
    );
  }

  deleteProduct(event: Event, id: string, productName: string): void {
    event.stopPropagation();

    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'PRODUCT_LIST.DELETE_DIALOG.TITLE',
          body: 'PRODUCT_LIST.DELETE_DIALOG.BODY',
          translateParams: { productName }
        }
      })
      .afterClosed()
      .pipe(
        filter(v => v),
        switchMap(() => this.productsService.deleteProduct(id))
      )
      .subscribe(
        () => {
          this.products = this.products.filter(product => product.id !== id);
          this.dataSource = new MatTableDataSource(this.products);
          this.dataSource.paginator = this.paginator;
          this.toastr.success(
            this.translate.instant('PRODUCT_LIST.COMPONENT.ITEM_REMOVED'),
            this.translate.instant('PRODUCT_LIST.COMPONENT.SUCCESS')
          );
        },
        error => {
          LoggerService.log('ProductListComponent::deleteProduct', error);
          this.toastr.error(this.translate.instant('PRODUCT_LIST.COMPONENT.ITEM_REMOVE_ERROR'));
        }
      );
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/products/product-list/product-list.component.ts